/**
 * The active account for *this tab*, used as the `x-uid` hint on requests and
 * forwarded to other apps on redirect.
 *
 * Priority mirrors the accounts store `init()` (minus the REST fallback, which
 * needs the store): impersonation target → this tab's selected account →
 * the new-tab default.
 *
 * Per-tab by design: since DAB-559 the `dbl2` cookie is just the set of
 * logged-in accounts and is never reordered (see accounts store `switchAccount`),
 * so the active account is a client-side, per-tab choice — two tabs can be
 * "active" as different accounts at once. The server resolves identity from the
 * `x-uid` we send, not from cookie order.
 */
export function getActiveUid(): string | null {
  return sessionStorage.getItem('impersonate') || sessionStorage.getItem('uid') || localStorage.getItem('uid') || null;
}

/** True when this tab is impersonating another user (admin "view as"). */
export function isImpersonating(): boolean {
  return Boolean(sessionStorage.getItem('impersonate'));
}
